import React, { Component } from 'react';
import {Modal,Button, FormControl, Alert, Container,Col,Row} from 'react-bootstrap';
import { SSL_OP_NO_TLSv1_2 } from 'constants';

class AddDomainModal extends Component {
    constructor(props){
        super(props);
        this.state={
            DomainInputValue:''
        }
        this.domainInputValueChange = this.domainInputValueChange.bind(this);
        this.submitAddDomain = this.submitAddDomain.bind(this);
        this.domainInputValueKeypress = this.domainInputValueKeypress.bind(this);
    }

    domainInputValueChange({target}){
        this.setState({DomainInputValue: target.value});
    }

    async submitAddDomain({target}){
        try{
            await this.props.handleAddDomain(this.state.DomainInputValue);
            this.setState({
                DomainInputValue:''
            })
        }catch(ex){
        }

    }

    domainInputValueKeypress(e){
        if(e.key === "Enter"){
            this.submitAddDomain(e.target);
        }
    }

    render(){
        return(
            <Modal show={this.props.showAddDomainModal} animation={false} className="distkey-modal gc-form">
              <Modal.Header>
                <Modal.Title>Add a Hostname</Modal.Title>
              </Modal.Header>
          
              <Modal.Body>
                {this.props.supportWildcard ? 
                (<Container>
                    <Row>
                        <Col md={1} style={{padding: 10 }}><h2>*.</h2> </Col>
                        <Col md={11} style={{paddingLeft:0}}>
                            <FormControl type="text" placeholder="Enter a hostname" value={this.state.DomainInputValue} onChange={this.domainInputValueChange} onKeyPress={this.domainInputValueKeypress} />
                        </Col>
                    </Row>
                </Container>)
                :
                <Container>
                    <Row>
                        <Col md={12}>
                            <FormControl type="text" placeholder="Enter a hostname" value={this.state.DomainInputValue} onChange={this.domainInputValueChange} onKeyPress={this.domainInputValueKeypress} />
                        </Col>
                    </Row>
                </Container>
                }

             

              {this.props.alert && 
              <Alert variant={this.props.alert.Status}>{this.props.alert.Message}</Alert>}
              
              </Modal.Body>
          
              <Modal.Footer>
              {this.props.loading && 
                <i className="fa-spinner fa fa-spin"></i>
              }
                <Button className="gc-btn primary-action" onClick={this.submitAddDomain}>Add Hostname</Button>
                <Button className="gc-btn" onClick={this.props.handleCloseAddDomainModal}>Close</Button>
              </Modal.Footer>
            </Modal>
        )
    }
}

export default AddDomainModal;